import React, { useEffect, useRef } from 'react'
import LoginMethodFrame, {
  LoginMethodContentsOnSubmitProps,
} from '../shared/LoginMethodFrame'
import PasskeyProgressIcon from '../icons/PasskeyProgressIcon'
import {
  InjectedSigninMethodProps,
  withSigninMethodProps,
} from '../../context/withSigninMethodProps'
import { useSigninWithPasskey } from '../../hooks/useAuthActions'
import {
  browserSupportsWebAuthn,
  WebAuthnAbortService,
} from '@simplewebauthn/browser'

type PureSigninPasskeyContentsProps = {
  onCancel: (error: string) => void
} & LoginMethodContentsOnSubmitProps

const PureSigninPasskeyContents = ({
  recaptchaPromise,
  recaptchaLoading,
  onSubmit,
  onCancel,
  email,
}: PureSigninPasskeyContentsProps) => {
  return (
    <div>
      <input
        type="text"
        name="email"
        value={email}
        autoComplete="username"
        readOnly
        hidden
      />
      <div className="flex items-center justify-center">
        <PasskeyProgressIcon />
      </div>
      <p className="text-center mt-3">Complete sign-in using your passkey</p>
    </div>
  )
}

type PureSigninPasskeyProps = {
  recaptcha?: boolean
  onCancel: PureSigninPasskeyContentsProps['onCancel']
} & InjectedSigninMethodProps

export const PureSigninPasskey = ({
  onSubmit,
  onCancel,
  email,
  loading,
  onPreviousStep,
  ...props
}: PureSigninPasskeyProps) => (
  <LoginMethodFrame
    title="Sign in with passkey"
    loading={false}
    recoveryPrompt={null}
    onPreviousStep={null}
    {...{ email, ...props }}
  >
    <PureSigninPasskeyContents {...{ email, onSubmit, onCancel }} />
  </LoginMethodFrame>
)

const BoundSigninPasskey = withSigninMethodProps(PureSigninPasskey)

export const SigninPasskey = () => {
  const signinWithPasskey = useSigninWithPasskey()

  useEffect(() => {
    const timeoutId = setTimeout(signinWithPasskey, 200)
    return () => {
      clearTimeout(timeoutId)
      WebAuthnAbortService.cancelCeremony()
    }
  }, []) // Only run on component mount

  return <BoundSigninPasskey onCancel={() => null} /> // TODO: Fix oncancel handling
}

export default SigninPasskey
